import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import pagnationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import BootstrapTable2 from 'react-bootstrap-table-next';
import { CirclePicker } from 'react-color';
import Lib from '../../../commons/lib';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from '../services';
import { PaginationTotal, DatetimePicker } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import _ from 'lodash';
import moment from 'moment';
import NumberFormatter from '../../../commons/NumberFormatter';
import SlaveAvInput from '../../../commons/SlaveAvInput';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';

class BufeKinalat extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableTermekStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'LOAD',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // FORM VALUES
      formAzonosito: '',
      formSzinkod: '',
      formNev: '',
      formAllapot: '',
      formCsoportAllapot: '',
      formRovidnev: '',
      formAfaertek: '',
      formListaar: '',
      formNettoar: '',
      formKezdete: null,
      formVege: null,
      formNTAKKategoria: '',
      formNTAKKiszereles: '',
      formNTAKMennyisegiEgyseg: '',
      formCikkid: '',
      formCikk: '',
      formCsoport: '',
      formAkcios: false,
      formBufe: '',
      currentTermekcsoport: {},
      currentTermek: {},
      currentRow: [],
      currentTermekRow: [],
      currentId: null,
      currentTermekId: null,
      currentTermekCsoportId: null,
      termekCsoportId: null,
      baseJson: [],
      termekJson: [],
      termektortenetJson: [],
      modalState: false,
      modalTermekState: false,
      saveButtonLoading: false,
      currentBufe: '',
      page: 1,
      sizePerPage: '',
      defaultCurrencyAzon: null,
      bufeOptions: [],
      ntakKategoriak: [],
      ntakKategoriaOptions: [],
      ntakMennyisegiEgysegOptions: [],
      ntakInfo: '',
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
    };

    this.pageSize = 25;
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.initTab();
      }
    }
  }
  
  componentDidMount() {
    // Typical usage (don't forget to compare props):
    if (this.props.active) {
      this.initTab();
    }
    this.selected = false;
  }

  getDefaultCurrency = () => {
    Services.getDefaultCurrency((err, res) => {
      if (!err) {
        this.setState({ defaultCurrencyAzon: res[0].azonosito });
      } else {
        this.setState({ defaultCurrencyAzon: '' });
      }
    });
  }

  onRowSelect = (row) => {
    this.setState({ currentTermekcsoport: row, currentRow: [row.id], currentTermekRow: [], currentTermekCsoportId: row.id });
    this.getTermekList(row.id);
    this.getTermekTortenetList(null);
  }

  onTermekRowSelect = (row) => {
    this.setState({ currentTermek: row, currentTermekRow: [row.id], currentTermekId: row.termekid });
    this.getTermekTortenetList(row.termekid);
  }

  toggleTermekModal = () => {
    this.setState(prevState => ({ modalTermekState: !prevState.modalTermekState }));
  }

  toggleModal = () => {
    this.setState(prevState => ({ modalState: !prevState.modalState }));
  }

  initTab = () => {
    this.setState({
      tableStatus: 'LOAD'
    });
    Services.listBufekSelect((err, res) => {
      if (!err) {
        if (res[0].length === 1) {
          this.getTermekcsoportList(res[0][0].id);
        }

        let bufeOptions = [];
        res[0].forEach(e => bufeOptions.push(<option key={e.id} value={e.id}>{e.nev + ' (' + e.kod + ')'}</option>));

        Services.initTermekListaTab((err2, res2) => {
          if (!err2) {
              let filters = {};
              let statuszOptions = res2[0].statusz.map((e) => {
                filters[e.name] = e.caption;
    
                return <option key={e.name} value={e.name}>{e.caption}</option>;
              });
              this.setState({
                statusz: res2[0].statusz,
                statuszOptions: statuszOptions,
                filterOptions: filters,
              });
          } else {
            this.setState({ tableStatus: 'NETW' });
          }
        })

        this.setState({
          bufeOptions: bufeOptions,
          formBufe: '',
          currentBufe: '',
          sizePerPage: this.pageSize,
          currentRow: [],
        }, () => {
          if (res[0].length > 0) {
            this.handleBufeSelectChange({ target: { type: '', value: res[0][0].id, name: 'formBufe' } });
          }
        });
      } else {
        this.setState({
          tableStatus: 'NETW'
        });
      }
    });

    
  }

  getTermekcsoportList = (id) => {
    this.setState({
      tableStatus: 'LOAD'
    });
    Services.listTermekCsoport(id, null, (err, res) => {
      if (!err) {
        this.setState({
          tableStatus: res[0].length === 0 ? 'DATA' : 'TABL',
          baseJson: res[0]
        }, () => {
          this.setPageAndSize(1, this.pageSize - 1);
        });
      } else {
        this.setState({
          tableStatus: 'NETW'
        });
      }
    });
  }

  getTermekList = (termekCsoportId) => {
    this.setState({
      tableTermekStatus: 'LOAD'
    });
    Services.listTermek(termekCsoportId, (err, res) => {
      if (!err) {
        this.setState({
          tableTermekStatus: res[0].length === 0 ? 'DATA' : 'TABL',
          termekJson: res[0],
          termekCsoportId: res[0].id
        });
      } else {
        this.setState({
          tableTermekStatus: 'NETW'
        });
      }
    });
  }

  getTermekTortenetList = (id) => {
    if (id === null) {
      this.setState({
        tableTermekTortenetStatus: 'DATA',
        termektortenetJson: []
      });
    } else {
      this.setState({
        tableTermekTortenetStatus: 'LOAD'
      });
      Services.listTermekTortenet(id, (err, res) => {
        if (!err) {
          this.setState({
            tableTermekTortenetStatus: res[0].length === 0 ? 'DATA' : 'TABL',
            termektortenetJson: res[0]
          });
        } else {
          this.setState({
            tableTermekTortenetStatus: 'NETW'
          });
        }
      });
    }
  }

  handleBufeSelectChange = (e) => {
    this.setState({ currentTermekRow: [] });
    this.getTermekTortenetList(null);
    if (!this.state.defaultCurrencyAzon) {
      this.getDefaultCurrency();
    }
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      currentBufe: value,
      [target.name]: value,
      currentRow: []
    }, () => {
      if (value !== '') this.getTermekcsoportList(value);
    });
  }

  handleNTAKKategoriaChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    let infoObj = this.state.ntakKategoriak.find(x => x.id === parseInt(value, 10));
    this.setState({
      ntakInfo: infoObj ? infoObj.leiras : '',
      formNTAKKategoria: value
    });
  }

  handleNTAKMennyisegiEgysegChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      formNTAKMennyisegiEgyseg: value
    });
  }

  handleCsoportDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleCsoportTorles();
  }

  handleTermekDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTermekTorles();
  }

  handleTermekTortenetDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTermekTortenetTorles();
  }

  handleCsoportEditClick = (cell) => {
    this.setState({
      currentId: cell,
      formType: 'MOD',
      formStatus: 'LOAD',
      formAzonosito: '',
      formNev: '',
      formCsoportAllapot: '',
      formSzinkod: '',
    }, () => {
      this.getCsoportData(cell);
      this.toggleModal();
    });
  }

  handleSubmit = (e, submitFormObj) => {
    const {
      formSzinkod,
      formCsoportAllapot,
      formType,
      formBufe,
      currentId
    } = this.state;
    const { formAzonosito, formNev } = submitFormObj;

    this.setState({
      saveButtonLoading: true
    });

    this.setState({
      saveButtonLoading: true
    });

    if (formType === 'FEL') {
      let submitObj = {
        azonosito: formAzonosito,
        nev: formNev,
        bufeid: formBufe,
        szinkod: formSzinkod,
        allapot: formCsoportAllapot
      };

      Services.addTermekCsoport(submitObj, (err) => {
        if (!err) {
          this.toggleModal();
          this.getTermekcsoportList(this.state.formBufe);
          this.props.globals.addSuccess('Termékcsoport felvéve!');
          this.setState({
            currentTermekcsoport: {}
          });
        }
        this.setState({
          saveButtonLoading: false
        });
      });
    }

    if (formType === 'MOD') {
      let submitObj = {
        id: currentId,
        azonosito: formAzonosito,
        nev: formNev,
        bufeid: { id: formBufe },
        szinkod: formSzinkod,
        allapot: formCsoportAllapot
      };

      Services.editTermekCsoport(submitObj, (err) => {
        if (!err) {
          this.toggleModal();
          this.getTermekcsoportList(this.state.formBufe);
          this.props.globals.addSuccess('Termékcsoport módosítva!');
          this.setState({
            currentTermekcsoport: {}
          });
        }
        this.setState({
          saveButtonLoading: false
        });
      });
    }
  }

  handleTermekSubmit = (e, submitFormObj) => {
    const {
      formListaar,
      formSzinkod,
      formAllapot,
      formAkcios,
      formType,
      formCikk,
      formKezdete,
      formVege,
      currentId,
      currentTermekId,
      formBufe,
      currentTermekcsoport,
      formNTAKKategoria,
      formNTAKKiszereles,
      formNTAKMennyisegiEgyseg,
    } = this.state;
    const {
      formAzonosito,
      formRovidnev
    } = submitFormObj;
    if (formListaar === null || formListaar === '') {
      this.props.globals.addError("Az eladási ár mező kitöltése kötelező!");
    } else {
      this.setState({
        saveButtonLoading: true
      });
      this.setState({
        saveButtonLoading: true
      });
      if (formType === 'FEL') {
        let submitObj = {
          allapot: formAllapot,
          rovidnev: formRovidnev,
          szinkod: formSzinkod,
          azonosito: formAzonosito,
          cikkid: formCikk.id,
          bufeid: formBufe,
          termekcsoportid: currentTermekcsoport.id,
          ntakkategoriaid: formNTAKKategoria,
          ntakmennyiseg: formNTAKKiszereles,
          ntakmennyisegiegysegid: formNTAKMennyisegiEgyseg,
          kezdete: formKezdete ? TimeFormatter.formatIso(formKezdete) : null,
          listaar: NumberFormatter.removeSpacesFromString(formListaar),
          akcios: formAkcios
        };

        Services.addTermek(submitObj, (err) => {
          if (!err) {
            this.toggleTermekModal();
            this.getTermekList(currentTermekcsoport.id);
            this.getTermekTortenetList(null);
            this.props.globals.addSuccess('Termék felvéve!');
            this.setState({
              currentTermekRow: '',
            });
          }
          this.setState({
            saveButtonLoading: false,
          });
        });
      }

      if (formType === 'MOD') {
        let submitObj = {
          id: currentId,
          cikkid: formCikk.id,
          allapot: formAllapot,
          rovidnev: formRovidnev,
          ntakkategoriaid: formNTAKKategoria,
          ntakmennyiseg: formNTAKKiszereles,
          ntakmennyisegiegysegid: formNTAKMennyisegiEgyseg,
          szinkod: formSzinkod,
          listaar: NumberFormatter.removeSpacesFromString(formListaar),
          akcios: formAkcios ? formAkcios : false,
          kezdete: formKezdete ? TimeFormatter.formatIso(formKezdete) : null,
          vege: formVege ? TimeFormatter.formatIso(formVege) : null,
        };

        Services.editTermek(submitObj, (err) => {
          if (!err) {
            this.toggleTermekModal();
            this.getTermekList(this.state.currentTermekcsoport.id);
            this.getTermekTortenetList(currentTermekId);
            this.props.globals.addSuccess('Termék módosítva!');
            this.setState({
              currentTermekRow: '',
            });
          }
          this.setState({
            saveButtonLoading: false,
          });
        });
      }
    }
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMKEZDETE':
          this.setState({ formKezdete: (moment(e).startOf('day')) });
          break;
        case 'FORMVEGE':
          this.setState({ formVege: (moment(e).endOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMKEZDETE':
          //this.handleDateInputChange(e, v, 'reszletesForgalomKezdete')
          console.log('ve', (v === '' ? null : e))
          this.setState({ formKezdete: (v === '' ? null : e) });
          break;
        case 'FORMVEGE':
          this.setState({ formVege: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }

  handleColorChange = (color) => {
    this.setState({ formSzinkod: color.hex.substr(1, 6) });
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formAzonosito: '',
      formNev: '',
      formCsoportAllapot: 'AKTIV',
      formSzinkod: '',
      formAllapot: 'AKTIV'
    }, () => {
      this.toggleModal();
    });
  }

  handleTermekEditClick = (cell) => {
    this.setState({
      currentId: cell,
      formType: 'MOD',
      formStatus: 'LOAD',
      formListaar: null,
      formNettoar: null,
      formKezdete: null,
      formVege: null,
      formAllapot: '',
      formAkcios: false,
      formCikkid: '',
      formCsoport: '',
      formCikk: '',
      formNTAKKategoria: '',
      ntakInfo: '',
      formNTAKKiszereles: '',
      formNTAKMennyisegiEgyseg: '',
    }, () => {
      this.initNTAKData();
      this.getTermekData(cell);
      this.toggleTermekModal();
    });
  }

  handleTermekTortenetClick = (cell) => {
    this.setState({
      currentId: cell
    }, () => {
      this.getTermekTortenetList(this.state.currentId);
    });
  }

  handleTermekNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formAzonosito: '',
      formRovidnev: '',
      formAllapot: 'AKTIV',
      formSzinkod: '',
      formKezdete: null,
      formVege: null,
      formCikk: '',
      formCsoport: '',
      formAkcios: false,
      formListaar: '',
      formNettoar: '',
      formAfaertek: '',
      formNTAKKategoria: '',
      ntakInfo: '',
      formNTAKKiszereles: '',
      formNTAKMennyisegiEgyseg: '',
    }, () => {
      this.initNTAKData();
      this.toggleTermekModal();
    });
  }

  /**
  * Törli az adott termékcsoportot.
  */
  deleteTermekcsoport = () => {
    this.toggleCsoportTorles();
    Services.deleteTermekCsoport(this._currentDeleteId, (err) => {
      if (!err) {
        this.getTermekcsoportList(this.state.formBufe);
        this.setState({ currentRow: [], currentTermekRow: [], currentTermek: {}, currentTermekcsoport: {} });
        this.props.globals.addSuccess('Termékcsoport törölve!');
      }
    });
  }

  deleteTermek = () => {
    this.toggleTermekTorles();
    Services.deleteTermek(this._currentDeleteId, (err) => {
      if (!err) {
        this.getTermekTortenetList(null);
        this.getTermekList(this.state.currentTermekcsoport.id);
        this.setState({ currentTermekRow: [], currentTermek: {} });
        this.props.globals.addSuccess('Termék törölve!');
      }
    });
  }

  deleteTermekTortenet = () => {
    this.toggleTermekTortenetTorles();
    Services.deleteTermekTortenet(this._currentDeleteId, (err) => {
      if (!err) {
        this.getTermekTortenetList(this.state.currentTermekId);
        this.props.globals.addSuccess('Terméktörténet törölve!');
      }
    });
  }

  /** Meglévő termékcsoport törlés megerősítő modal kapcsolása. */
  toggleCsoportTorles = () => {
    this.setState((prevState) => { return ({ modalCsoportTorles: !prevState.modalCsoportTorles }); });
  }

  toggleTermekTorles = () => {
    this.setState((prevState) => { return ({ modalTermekTorles: !prevState.modalTermekTorles }); });
  }

  toggleTermekTortenetTorles = () => {
    this.setState((prevState) => { return ({ modalTermekTortenetTorles: !prevState.modalTermekTortenetTorles }); });
  }

  getCsoportData = (id) => {
    this.setState({
      formStatus: 'LOAD',
      formId: id
    });
    Promise.all([
      this.getTermekCsoport(id),
    ])
      .then(() => {
        this.setState({
          formStatus: 'DATA'
        });
      })
      .catch(() => {
        this.setState({
          formStatus: 'NETW'
        });
      });
  }

  initNTAKData = () => {
    Promise.all([
      this.initNTAK(),
    ])
      .then(() => {
        this.setState({
          formStatus: 'DATA'
        });
      })
      .catch(() => {
        this.setState({
          formStatus: 'NETW'
        });
      });
  }

  getTermekData = (id) => {
    this.setState({
      formStatus: 'LOAD',
      formId: id
    });
    Promise.all([
      this.getTermek(id),

    ])
      .then(() => {
        this.setState({
          formStatus: 'DATA'
        });
      })
      .catch(() => {
        this.setState({
          formStatus: 'NETW'
        });
      });
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['BUFE_KINALAT'], true);
  }

  hasRoleRendez = () => {
    return this.props.globals.hasRoleSpec(['BUFE_KINALATSORREND']);
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  handleTermekcsoportOrderChange = (id, rowObj, rowIndex, plus) => {
    let mostani = this.state.baseJson.find((element) => {
      return element === rowObj;
    });
    let masik = this.state.baseJson[((this.state.page - 1) * this.state.sizePerPage) + rowIndex + plus];
    let sorszamseged = mostani.sorszam;
    mostani.sorszam = masik.sorszam;
    masik.sorszam = sorszamseged;
    this.state.baseJson.sort((a, b) => {
      return a.sorszam - b.sorszam;
    });
    this.setState({ baseJson: this.state.baseJson });
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  akcioFormatter = (cell) => {
    return cell ? '✔' : '✘';
  }

  isFirstObj = (rowObj) => {
    return rowObj.sorszam === Math.min.apply(Math, this.state.baseJson.map(x => x.sorszam));
  }

  isLastObj = (rowObj) => {
    return rowObj.sorszam === Math.max.apply(Math, this.state.baseJson.map(x => x.sorszam));
  }

  iconFormatter = (cell, rowObj, rowIndex) => {
    return (
      <div>
        {this.hasRoleKarb() && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleCsoportEditClick(cell)} />
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleCsoportDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
          </React.Fragment>
        )}
        {this.hasRoleRendez() && (
          <React.Fragment>
            {!this.isFirstObj(rowObj) && (
              <Button className="table-action-icon" id={'action-view-' + cell + 'fel'} onClick={() => { this.handleTermekcsoportOrderChange(cell, rowObj, rowIndex, -1) }}>
              <i class="fa fa-arrow-up" />
              </Button>
            )}
            {!this.isLastObj(rowObj) && (
              <Button className="table-action-icon" id={'action-view-' + cell + 'le'} onClick={() => { this.handleTermekcsoportOrderChange(cell, rowObj, rowIndex, 1) }}>
              <i class="fa fa-arrow-down" />
              </Button>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }

  iconFormatterTermek = (cell, row) => {
    return (
      <div>
        {
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleTermekEditClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
          </React.Fragment>
        }
        <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleTermekDeleteClick(cell)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
      </div>
    );
  }

  iconFormatterTortenet = (cell, row) => {
    return (
      <div>
        {row.vege == null && (
          <React.Fragment>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleTermekTortenetDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  styleSzinkod = (szinkod) => {
    return {
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod
    };
  }
  
  rendez = () => {
    let rendezesBean = {};
    rendezesBean.idk = this.state.baseJson.map((element) => {
      return element.id;
    });
    rendezesBean.bufeid = this.state.currentBufe;
    Services.rendezTermekcsoport(rendezesBean, (err, res) => {
      if (!err) {
        this.props.globals.addSuccess('Sorrend sikeresen elmentve!');
        this.getTermekcsoportList(this.state.currentBufe);
      }
    });
  }

  getTermekCsoport = (id) => {
    return new Promise((resolve, reject) => {
      Services.getTermekCsoport(id, (err, res) => {
        if (!err) {
          this.setState({
            formAzonosito: this.nullToString(res[0].azonosito),
            formNev: this.nullToString(res[0].nev),
            formCsoportAllapot: this.nullToString(res[0].allapot.name),
            formSzinkod: this.nullToString(res[0].szinkod),
          });
          resolve(res[0]);
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  getTermek = (id) => {
    return new Promise((resolve, reject) => {
      Services.getTermek(id, (err, res) => {
        if (!err) {
          let infoObj = res[0].ntakkategoriaid && this.state.ntakKategoriak.find(x => x.id === res[0].ntakkategoriaid);
          this.setState({
            currentTermekId: this.nullToString(res[0].termekid),
            termekCsoportId: this.nullToString(res[0].termekcsoportid),
            formCikk: {
              id: this.nullToString(res[0].cikkid),
              nev: this.nullToString(res[0].cikknev + ' (' + res[0].cikkazonosito + ')')
            },
            formAfaertek: this.nullToString(res[0].afaertek),
            formAzonosito: this.nullToString(res[0].azonosito),
            formAllapot: this.nullToString(res[0].allapot.name),
            formRovidnev: this.nullToString(res[0].rovidnev),
            formNTAKKategoria: this.nullToString(res[0].ntakkategoriaid),
            formNTAKKiszereles: this.nullToString(res[0].ntakmennyiseg),
            formNTAKMennyisegiEgyseg: this.nullToString(res[0].ntakmennyisegiegysegid),
            formSzinkod: this.nullToString(res[0].szinkod),
            formAkcios: this.nullToString(res[0].akcios),
            formListaar: this.emptyOrNull(res[0].listaar),
            formKezdete: null,
            formVege: null,
            ntakInfo: infoObj && infoObj.leiras,
          });
          resolve(res[0]);
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  initNTAK = () => {
    return new Promise((resolve, reject) => {
      Services.initNTAK((err, res) => {
        if (!err) {
          this.setState({
            ntakKategoriak: res[0] && res[0].kategoria ? res[0].kategoria : [],
            ntakKategoriaOptions: res[0] && res[0].kategoria && res[0].kategoria.map(e => <option key={e.id} value={e.id}>{e.fokategorianev + ' - ' + e.nev}</option>),
            ntakMennyisegiEgysegOptions: res[0].mennyisegiegyseg.map(e => <option key={e.id} value={e.id}>{e.nev}</option>),
          });

          resolve(res[0]);
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  loadCikkChange = (input, callback) => {
    if (input.length !== 0) {
      Services.searchCikk(input, (err, res) => {
        if (!err) {
          let newArray = [];
          res[0].forEach((item) => {
            let newItem = item;
            newItem.nev = newItem.megnevezes + ' (' + newItem.cikkszam + ') ';
            newArray.push(newItem);
          });
          callback(newArray);
        }
      });
    }
  }

  handleChangeCikk = (value) => {
    if (value && value !== '') {
      this.setState({
        formCikk: value,
        formAfaertek: value.aktualisAfaErtek,
        formRovidnev: value.megnevezes.substring(0, 25),
        formAzonosito: value.cikkszam.substring(0, 15)
      });
    } else {
      this.setState({
        formCikk: '',
      });
    }
  }

  renderCsoportFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új termékcsoport felvétele';
      case 'MOD':
        return 'Termékcsoport módosítása';
      default:
        return '';
    }
  }

  renderTermekFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új termék felvétele';
      case 'MOD':
        return 'Termék módosítása';
      default:
        return '';
    }
  }

  renderForm = () => {
    const {
      formAzonosito,
      formSzinkod,
      formNev,
      formCsoportAllapot
    } = this.state;

    return (
      <React.Fragment>
        <div>
          <Label for="formAzonosito">Azonosító: *</Label>
          <RFField
            name="formAzonosito"
            id="formAzonosito"
            required
            maxLength="15"
            value={formAzonosito}
            onChange={this.handleInputChange}
            disabled={this.state.formType === 'MOD'}
          />
        </div>

        <div>
          <Label for="formNev">Megnevezés: *</Label>
          <RFField
            name="formNev"
            id="formNev"
            required
            maxLength="30"
            value={formNev}
            onChange={this.handleInputChange}
          />
          
        </div>
        <RFField
          type="select"
          name="formCsoportAllapot"
          id="formCsoportAllapot"
          label="Állapot: *"
          errorMessage="Kötelező mező!"
          required
          value={formCsoportAllapot}
          onChange={this.handleInputChange}
          selectOptions={this.state.statuszOptions}
        />
        <Label for="szinkod">Színválasztás: *</Label>
        <CirclePicker name="szinkod" id="szinkod" color={formSzinkod} onChangeComplete={this.handleColorChange} colors={["#607d8b", "#795548", "#9c27b0", "#baaaff", "#3f51b5", "#2196f3", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#16ed75", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#f44336", "#e91e63"]} />
      </React.Fragment>
    );
  }

  renderTermekForm = () => {
    const {
      formAzonosito,
      formSzinkod,
      formRovidnev,
      formAllapot,
      formListaar,
      formKezdete,
      formVege,
      formAkcios,
      formCikk,
      formAfaertek,
    } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-10">
            <SelectField
              variant='async'
              label='Cikk megnevezése:'
              name="formCikk"
              id="formCikk"
              placeholder="Keresés megnevezés alapján..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              loadingMessage={() => 'Keresés...'}
              onChange={v => this.handleChangeCikk(v)}
              isClearable
              ignoreAccents={false}
              loadOptions={_.debounce(this.loadCikkChange, 1000)}
              isLoading={false}
              getOptionValue={option => option.id}
              getOptionLabel={option => option.nev}
              value={formCikk}
              cache={false}
              autoload={false}
            />
          </div>
          <div className="col-md-2">
            <Label for="formAfaertek">Áfa (%):</Label>
            <RFField
              name="formAfaertek"
              id="formAfaertek"
              disabled
              value={formAfaertek == '' ? '0' : formAfaertek}
            />
          </div>
        </div>

        <div className="row" style={{ paddingTop: 10 }}>
          <div className="col-md-4">
            <div>
              <Label for="formAzonosito">Azonosító: *</Label>
              <RFField
                name="formAzonosito"
                id="formAzonosito"
                required
                maxLength="15"
                value={formAzonosito}
                disabled={this.state.formType === 'MOD'}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
          <div className="col-md-4">
            <RFField
              type="select"
              name="formAllapot"
              id="formAllapot"
              label="Állapot: *"
              errorMessage="Kötelező mező!"
              required
              value={formAllapot}
              onChange={this.handleInputChange}
              selectOptions={this.state.statuszOptions}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-10">
            <div>
              <Label for="formRovidnev">Megjelenített név: *</Label>
              <RFField
                name="formRovidnev"
                id="formRovidnev"
                required
                maxLength="20"
                value={formRovidnev}
                onChange={this.handleInputChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <RFForm onSubmit={() => {}}>
              <RFField
                type="select"
                name="formNTAKKategoria"
                label="NTAK fő-/alkategória:"
                value={this.state.formNTAKKategoria}
                onChange={this.handleNTAKKategoriaChange}
                defaultSelect={<option value="">Válassz NTAK fő-/alkategóriát...</option>}
                selectOptions={this.state.ntakKategoriaOptions}
              />
            </RFForm>
          </div>
          {this.state.formNTAKKategoria && (
            <div className="col-md-2" style={{ fontSize: '1.5em', paddingTop: '30px' }}>
              <CustomTooltip text={this.state.ntakInfo} id="infoKategoria" />
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-md-5">
            <SlaveAvInput
              id="formNTAKKiszereles"
              label="NTAK kiszerelés:"
              max="9999999"
              min="0"
              value={this.state.formNTAKKiszereles}
              onChange={this.handleInputChange}
              szuroTipus={NumberFormatter.OSSZEG}
              emptyStringOnZero
              autoComplete="off"
            />
          </div>
          <div className="col-md-5">
            <RFForm>
              <RFField
                type="select"
                name="formNTAKMennyisegiEgyseg"
                label="NTAK mennyiségi egység:"
                value={this.state.formNTAKMennyisegiEgyseg}
                onChange={this.handleNTAKMennyisegiEgysegChange}
                defaultSelect={<option value="">Válassz NTAK mennyiségi egységet...</option>}
                selectOptions={this.state.ntakMennyisegiEgysegOptions}
              />
            </RFForm>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4" style={{ paddingBottom: 10, paddingTop: 10 }}>
            Színválasztás
        </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <CirclePicker name="szinkod" id="szinkod" color={formSzinkod} onChangeComplete={this.handleColorChange} colors={["#607d8b", "#795548", "#9c27b0", "#baaaff", "#3f51b5", "#2196f3", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#16ed75", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#f44336", "#e91e63"]} />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <br />
            <h5>Árváltozás adatai</h5>
            <br />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <SlaveAvInput
              id="formListaar"
              label={"Eladási ár (" + this.state.defaultCurrencyAzon + "): *"}
              max="9999999"
              min="0"
              value={formListaar}
              onChange={this.handleInputChange}
              szuroTipus={NumberFormatter.OSSZEG}
              emptyStringOnZero
            />
          </div>
          <div className="col-md-4">
            <SlaveAvInput
              id="formListaarNetto"
              label={"Nettó ár (" + this.state.defaultCurrencyAzon + "): *"}
              max="9999999"
              min="0"
              disabled
              value={(!formAfaertek || formAfaertek == 0) ? formListaar : Math.round(NumberFormatter.removeSpacesFromString(formListaar) / (1 + (formAfaertek / 100)) * 100) / 100}
              szuroTipus={NumberFormatter.OSSZEG}
              emptyStringOnZero
            />
          </div>
          <div className="col-md-1" />
          <div className="col-md-2" style={{ paddingLeft: 0, paddingTop: '35px' }}>
            <div check>
              <div className="row">
                <RFField type="checkbox"
                  label="Akciós"
                  name="formAkcios"
                  id="formAkcios"
                  value={formAkcios}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8" style={{ paddingTop: 10 }}>
            <DatetimePicker
              // format="YYYY-MM-DD HH:mm"
              label={'Kezdete: '}
              name="formKezdete"
              id="formKezdete"
              error="Érvénytelen dátum"
              value={formKezdete && new Date(formKezdete)}
              //onChange={(e, v) => this.handleDateInputChange(e, v, 'formKezdete')}
              onChange={(e,v) => {this.handleDateChange(e,v,'FORMKEZDETE')}}
              onSelect={(e,v) => { this.selected = true }}
              timePrecision="seconds"
            />
          </div>
          {this.state.formType == 'MOD' ? <div className="col-md-8">
            <DatetimePicker
              label={'Vége: '}
              // format="YYYY-MM-DD HH:mm"
              name="formVege"
              id="formVege"
              error="Érvénytelen dátum"
              value={formVege && new Date(formVege)}
              //onChange={(e, v) => this.handleDateInputChange(e, v, 'formVege')}
              onChange={(e,v) => {this.handleDateChange(e,v,'FORMVEGE')}}
              onSelect={(e,v) => { this.selected = true }}
              timePrecision="seconds"
            />
          </div> : <div />}
        </div>
      </React.Fragment>
    );
  }

  setPageAndSize = (page, sizePerPage) => {
    this.setState({ page, sizePerPage });
  }

  formatOsszeg = (cell) => {
    return NumberFormatter.formatterSpaceOsszeg(cell) + ' ' + this.state.defaultCurrencyAzon;
  }

  renderCsoportTable = () => {
    let selectRowProp = {
      mode: 'radio',
      onSelect: this.onRowSelect,
      selected: this.state.currentRow
    };

    const options = {
      sizePerPage: this.pageSize,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '25', value: 25 },
        { text: '50', value: 50 }
      ],
      onSizePerPageChange: (sizePerPage, page) => {
        this.setPageAndSize(page, sizePerPage);
      },
      onPageChange: (page, sizePerPage) => {
        this.setPageAndSize(page, sizePerPage);
      }
    };

    const columns = [
      {
        dataField: 'nev',
        text: 'Termékcsoport',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szinkod',
        text: 'Színkód',
        style: this.styleSzinkod,
        formatter: () => { return '' },
        sort: true
      },
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'allapot.name',
        align: 'center',
        text: 'Állapot',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter,
        sort: true
      },
    ];

    const columns2 = [
      ...columns,
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ]

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        filter={filterFactory()}
        data={this.state.baseJson}
        columns={(this.hasRoleKarb() || this.hasRoleRendez()) ? columns2 : columns}
        pagination={pagnationFactory(options)}
        selectRow={selectRowProp}
      />
    );
  }

  renderTermekTable = () => {

    let selectTermekRowProp = {
      mode: 'radio',
      onSelect: this.onTermekRowSelect,
      selected: this.state.currentTermekRow
    };

    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };

    const columns = [
      {
        dataField: 'rovidnev',
        text: 'Termék neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szinkod',
        text: 'Színkód',
        style: this.styleSzinkod,
        formatter: () => { return '' },
        sort: true
      },
      {
        dataField: 'cikknev',
        text: 'Cikk neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'egysegar',
        text: 'Egység ár',
        sort: true,
        style: NumberFormatter.styleTextAlign,
        formatter: this.formatOsszeg,
        sortFunc: (a, b, order) => {
          if (order === 'asc') {
            return a - b;
          }
          return b - a;
        }
      },
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'ntakkategoria',
        text: 'NTAK kategória',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
      },
      {
        dataField: 'akcios',
        text: 'Akciós',
        sort: true,
        align: 'center',
        formatter: this.akcioFormatter,
      },
      {
        dataField: 'allapot.name',
        align: 'center',
        text: 'Állapot',
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter,
        sort: true
      },

    ];

    const columns2 = [
      ...columns,
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatterTermek
      }
    ]

    let termekgomb = <p />;
    let termektabla;

    if (this.state.currentRow.length > 0) {
      termektabla = this.state.termekJson.length > 0 ? (
        <BootstrapTable2
          bootstrap4
          keyField="id"
          filter={filterFactory()}
          data={this.state.termekJson}
          columns={this.hasRoleKarb() ? columns2 : columns}
          pagination={pagnationFactory(options)}
          selectRow={selectTermekRowProp}
        />
      ) : <DataEmptyState hasImage />;
    }

    return (
      <div>
        {termekgomb}
        {termektabla}
      </div>
    );

  }

  renderTermekTortenetTable = () => {

    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };

    const columns = [
      {
        dataField: 'kezdete',
        text: 'Kezdete',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        formatter: datum => datum ? TimeFormatter.formatDateTime(datum) : "",
        sortFunc: (a, b, order) => {
          if (order === "asc") return a.localeCompare(b);
          return b.localeCompare(a);

        }
      },
      {
        dataField: 'vege',
        text: 'Vége',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        formatter: datum => datum ? TimeFormatter.formatDateTime(datum) : "",
        sortFunc: (a, b, order) => {
          if (order === "asc") {
            if (a == null || a == '') return 1;
            return a.localeCompare(b);
          }
          if (a == null || a == '') return -1;
          return b.localeCompare(a);
        }
      },
      {
        dataField: 'listaar',
        text: 'Egység ár',
        style: NumberFormatter.styleTextAlignWhiteSpace,
        formatter: this.formatOsszeg,
        sort: true,
        sortFunc: (a, b, order) => {
          if (order === 'asc') {
            return a - b;
          }
          return b - a;
        }
      },
      {
        dataField: 'akcios',
        text: 'Akciós',
        sort: true,
        align: 'center',
        formatter: this.akcioFormatter,
      },
    ];

    const columns2 = [
      ...columns,
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatterTortenet
      }
    ]

    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        filter={filterFactory()}
        data={this.state.termektortenetJson}
        columns={this.hasRoleKarb() ? columns2 : columns}
        pagination={pagnationFactory(options)}
      />
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-3">
            <RFForm onSubmit={() => {}}>
              <RFField type="select" name="formBufe" label="Büfé neve:" value={this.state.formBufe} onChange={this.handleBufeSelectChange}
              defaultSelect={<option value="">Válassz büfét...</option>}
              selectOptions={this.state.bufeOptions}
              />
            </RFForm>
          </div>
          <div className="col-md-12">
            {
              this.hasRoleKarb() &&
              this.state.formBufe && !(this.state.formBufe === '') &&
              (
                <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                  {'Új Termékcsoport'}
                </Button>
              )}
          </div>

          {(this.state.formBufe && this.state.formBufe !== '' && (
            <div className="col-md-12">
              {{
                LOAD: (<Loader />),
                DATA: (<DataEmptyState
                  hasImage
                  subtitle="Vigyél fel új tételt!"
                />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => this.getTermekcsoportList(this.state.currentBufe)}
                />),
                TABL: (this.renderCsoportTable())
              }[this.state.tableStatus]}
            </div>
          ))}

          <div className="col-md-2" style={{ float: 'right', paddingBottom: '10px' }}>
            {(this.state.tableStatus === 'TABL' && this.hasRoleRendez() ?
              <Button type="button" id="rendez" className="btn-cursor-pointer" color="success" onClick={this.rendez} style={{ paddingLeft: 10 }}><i className="fa fa-check" style={{ paddingLeft: 0, paddingRight: 5 }} />Sorrend mentése</Button>
              : <div />)}
          </div>

          <div className="col-md-12">
            {
              this.hasRoleKarb() &&
              !(this.state.currentRow.length === 0) &&
              (
                <Button className="pull-left table-new-button" color="primary" onClick={this.handleTermekNewClick}>
                  {'Új Termék'}
                </Button>
              )}
          </div>

          {(this.state.currentRow.length === 0) ? null : (

            <div className="col-md-12">
              {{
                LOAD: (<Loader />),
                DATA: (<DataEmptyState
                  hasImage
                  subtitle="Vigyél fel új tételt!"
                />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => this.getTermekList(this.state.currentTermekCsoportId)}
                />),
                TABL: (this.renderTermekTable())
              }[this.state.tableTermekStatus]}
            </div>
          )}

          {(this.state.currentTermekRow.length === 0) ? null : (

            <div className="col-md-12">
              {{
                LOAD: (<Loader />),
                DATA: (<DataEmptyState
                  hasImage
                  subtitle="Vigyél fel új tételt!"
                />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => this.getTermekTortenetList(this.state.currentTermekId)}
                />),
                TABL: (this.renderTermekTortenetTable())
              }[this.state.tableTermekTortenetStatus]}
            </div>
          )}
        </div>
        <RFForm
          onSubmit={this.handleSubmit}
          modalInsert
          title={this.renderCsoportFormTitle()}
          tagProps={{ isOpen: this.state.modalState, toggle: this.toggleModal, backdrop: 'static' }}
          footer={
            <>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
                disabled={!this.state.formSzinkod || this.state.formSzinkod === ''}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleModal}>Mégsem</Button>
            </>
          }
        >
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => this.getCsoportData(this.state.currentId)}
            />),
            DATA: (this.renderForm())
          }[this.state.formStatus]}
        </RFForm>
        <Modal isOpen={this.state.modalCsoportTorles} toggle={this.toggleCsoportTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a termékcsoportot?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteTermekcsoport}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleCsoportTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <RFForm
          onSubmit={this.handleTermekSubmit}
          modalInsert
          title={this.renderTermekFormTitle()}
          tagProps={{ isOpen: this.state.modalTermekState, toggle: this.toggleTermekModal, backdrop: 'static' }}
          footer={
            <>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
                disabled={!this.state.formSzinkod || this.state.formSzinkod === ''}
              >
                {'Mentés'}
              </ProgressButton>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleTermekModal}>Mégsem</Button>
            </>
          }
        >
          {{
            LOAD: (<Loader />),
            NETW: (<NetworkEmptyState
              hasImage
              submitClick={() => this.getTermekData(this.state.currentId)}
            />),
            DATA: (this.renderTermekForm())
          }[this.state.formStatus]}
        </RFForm>
        <Modal isOpen={this.state.modalTermekTorles} toggle={this.toggleTermekTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd ezt a terméket?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteTermek}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleTermekTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalTermekTortenetTorles} toggle={this.toggleTermekTortenetTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd a termék történetét?</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteTermekTortenet}>OK</Button>
            <Button type="button" color="secondary" onClick={this.toggleTermekTortenetTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }

}

BufeKinalat.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool,
};

export default BufeKinalat;
